import React, { useImperativeHandle, forwardRef, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Btn from "../Button/Button";

const AlertDialog: React.FC<any> = forwardRef((props: any, ref: any) => {
  const [open, setOpen] = React.useState(false);
  const [isButtonDisabled, setIsButtonDisabled]: any = useState(false);
  useImperativeHandle(ref, () => ({
    handleClickOpen: () => {
      setOpen(true);
      setIsButtonDisabled(false);
    },
    handleClose: () => {
      setOpen(false);
    },
  }));

  return (
    <div>
      <Dialog
        open={open}
        onClose={props.onDiscard}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {props.title ? props.title : null}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.description ? props.description : null}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          className="dialogactions"
          style={{ justifyContent: "center", paddingBottom: "24px" }}
        >
          <Btn
            onClick={() => {
              setIsButtonDisabled(!isButtonDisabled);
              props.onConfirm();
              // setIsButtonDisabled(false);
            }}
            type={"button"}
            btnText={props.confirm}
            disable={isButtonDisabled}
          />
          {props.discard ? (
            <Btn
              onClick={props.onDiscard}
              color={"default"}
              type={"button"}
              btnText={props.discard}
            />
          ) : null}
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default AlertDialog;
